import SpecsValidationIssueSummary from "./SpecsValidationIssueSummary";
import { useSpecsPageContext } from "./SpecsPageContext";

export default function SpecsPageValidationSummary() {
  const { validationResult, onOpenValidationDialog } = useSpecsPageContext();

  return (
    <SpecsValidationIssueSummary
      validationResult={validationResult}
      onOpenDetails={onOpenValidationDialog}
    />
  );
}
